export default __webpack_public_path__ + "static/media/client-ic-comment.63f17f4b.svg";